export default "__VITE_ASSET__858708aa__"